import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Mui Libraries
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';

// Slice
import { fetchNotificationPlatform } from '../../../pages/Integration/Marketplace/integrationsSlice';

// Components
import PlatformDrawer from '../../General/PlatformDrawer';

const NonintegratedPage = () => {

    const dispatch = useDispatch();
    const integrations = useSelector(state => state.integrations);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [platformName, setPlatformName] = useState('all');
    
    const platformCallback = (item) => {
        if (item) {          
            setPlatformName(item)
            setOrderDrawerVisible(true)
        } 
    }

    const orderOnClose = (values) => {
        setOrderDrawerVisible(false);
    };

    useEffect(() => {
        dispatch(fetchNotificationPlatform());
    }, [dispatch]);

    const PlatformComponent = ({ platform = [], currentCategory, searchField }) => {
        return (
            <>
                {
                    platform && platform.map((item) => {
                        if (item.name === 'Email' || item.name === 'Webhook' || item.name === 'Klaviyo') {
                            return (
                                <Grid
                                    key={item.name}
                                    item xs={12} sm={6} md={4} lg={3}
                                >
                                    <Box
                                        onClick={() => platformCallback(item.name)}
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                transform: 'translateY(-4px)'
                                            }
                                        }}
                                    >
                                        <Paper
                                            elevation={0}
                                            sx={{ 
                                                width: '100%',
                                                maxWidth: 160,
                                                height: 120,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: '16px',
                                                backgroundColor: '#FFFFFF',
                                                border: '1px solid #E2E8F0',
                                                p: 2.5,
                                                boxSizing: 'border-box',
                                                transition: 'all 0.2s ease-in-out',
                                                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
                                                '&:hover': {
                                                    borderColor: '#CBD5E1',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.02)'
                                                }
                                            }}
                                        >
                                            <Box
                                                className="nonintegration--images"
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    overflow: 'hidden'
                                                }}
                                            >
                                                <img
                                                    className="integration--logo"
                                                    src={item.image}
                                                    data-src={item.image}
                                                    alt={item.name}
                                                    title={item.name}
                                                    style={{
                                                        maxWidth: '85%',
                                                        maxHeight: '85%',
                                                        objectFit: 'contain',
                                                        transition: 'transform 0.2s ease-in-out'
                                                    }}
                                                />
                                            </Box>
                                        </Paper>
                                        
                                        <Typography
                                            title={item.name}
                                            variant="subtitle2"
                                            noWrap
                                            sx={{
                                                mt: 1.5,
                                                fontSize: '13.5px',
                                                fontWeight: 700,
                                                color: '#1E293B',
                                                textAlign: 'center',
                                                width: '100%',
                                                maxWidth: 160,
                                                letterSpacing: '-0.1px'
                                            }}
                                        >
                                            {item.name}
                                        </Typography>
                                    </Box>
                                </Grid>
                            )
                        }
                    })
                }
            </>
        )
    }

    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box', py: 1 }}>
            <Grid container spacing={3}>
                {integrations && integrations.platform && integrations.platform.loading === false ? (
                    <PlatformComponent
                        platform={integrations && integrations.platform.data}                        
                    />
                ) : (
                    // Asynchronous state load indicator wrapper frame match
                    integrations && integrations.platform && integrations.platform.loading === true && (
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                                <CircularProgress size={36} sx={{ color: '#1976d2' }} />
                            </Box>
                        </Grid>
                    )
                )}
            </Grid>
            
            <PlatformDrawer
                visible={orderDrawerVisible}
                onClose={orderOnClose}
                platform={platformName}               
            />
        </Box>
    );
};

export default NonintegratedPage;